module.exports = __webpack_public_path__ + "media/brands/magirus-deutz-8fa68666.png";